import Skeleton from 'react-loading-skeleton';

import Typography from '~/shared/components/Typography';
import FilterButton from '~/shared/components/filters/FilterButton';
import { SelectOption } from '~/shared/utils/types';

import FleetManagerFiltersSidePanel from '../AllVolumesFiltersSidePanel/AllVolumesFiltersSidePanel';

interface AllVolumesTableHeaderProps {
  dataCount: number | undefined;
  activeFilterCount: number;
  sidePanelOpen: boolean;
  onTogglePanel: () => void;
  onSetPanelOpen?: (open: boolean) => void;
  onResetFilters: () => void;
  appliedClusterNameFilters: SelectOption[];
  appliedInstanceFilters: SelectOption[];
  appliedVolumeIdFilters: SelectOption[];
  appliedVolumeTagFilters: SelectOption[];
  appliedAutoscaleState: string[];
}

export function AllVolumesTableHeader({
  dataCount,
  activeFilterCount,
  sidePanelOpen,
  onTogglePanel,
  onSetPanelOpen,
  onResetFilters,
  appliedClusterNameFilters,
  appliedInstanceFilters,
  appliedVolumeIdFilters,
  appliedVolumeTagFilters,
  appliedAutoscaleState,
}: AllVolumesTableHeaderProps) {
  return (
    <div className="flex justify-between pt-3 2xl:pt-[18px]  bgred/5">
      <div className="flex items-center gap-7 ">
        {dataCount !== undefined ? (
          <Typography variant="p1" fontWeight={500} className="text-primary-900 font-family-inter">
            {dataCount} Detected Volumes
          </Typography>
        ) : (
          <Skeleton
            containerClassName="block leading-[unset!important]"
            className="h-[20px] leading-[unset!important] rounded-[8px] "
            baseColor="var(--color-gray-200)"
            highlightColor="#FFFF"
            width={200}
          />
        )}
      </div>
      <div className="flex gap-2 items-cente justify-end w-full max-w-[713px]">
        <FilterButton
          activeFilterCount={activeFilterCount}
          onOpen={onTogglePanel}
          onClearAll={onResetFilters}
          size="md-responsive"
          variant="third"
        />
      </div>
      <FleetManagerFiltersSidePanel
        open={sidePanelOpen}
        onOpenChange={(open: boolean) => {
          if (onSetPanelOpen) {
            onSetPanelOpen(open);
          } else {
            // Fallback: toggle only when change differs to avoid accidental close/open loops
            if (open !== sidePanelOpen) {
              onTogglePanel();
            }
          }
        }}
        onResetFilters={onResetFilters}
        appliedClusterNameFilters={appliedClusterNameFilters}
        appliedInstanceFilters={appliedInstanceFilters}
        appliedVolumeIdFilters={appliedVolumeIdFilters}
        appliedVolumeTagFilters={appliedVolumeTagFilters}
        appliedAutoscaleState={appliedAutoscaleState}
      />
    </div>
  );
}
